function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXtimesLogoWhiteNoCircle = function SvgXtimesLogoWhiteNoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 79.375 79.375"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 39.688,
    cy: 39.688,
    r: 36.37,
    className: "cls-2",
    style: {
      stroke: "none",
      strokeWidth: "1.85208px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.616 53.546-5.056 5.057-13.86-13.86-13.94 13.942-5.056-5.057 13.94-13.94-13.858-13.86 5.056-5.056L39.7 34.632 53.562 20.77l5.056 5.056L44.76 39.685l13.858 13.859Z",
    className: "cls-1",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".79375px",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.43 78.34-71.49 71.49 71.49 71.49",
    className: "cls-3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    transform: "matrix(.26458 0 0 .26458 0 .045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.616 39.751c0-1.754 1.413-3.215 3.164-3.215S64.9 38 64.9 39.751s-1.366 3.167-3.12 3.167a3.16 3.16 0 0 1-3.164-3.167zM14.475 39.751c0-1.754 1.413-3.215 3.165-3.215 1.751 0 3.12 1.463 3.12 3.215s-1.366 3.167-3.12 3.167a3.16 3.16 0 0 1-3.165-3.167z",
    className: "cls-1",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: ".79375px",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgXtimesLogoWhiteNoCircle;